<div class="bold re-mb-15 md:re-mb-30">
  {{questionText()}}
</div>

<div class="re-h-230 re-flex re-flex-col re-justify-center">
  @switch (questionData()?.questionType) {
    @case (POLLQUESTIONTYPE['1-10_SCALE']) {
      <bdo-scale-question [questionData]="questionData()" (sendAnswer)="sendAnswer.emit($event)"></bdo-scale-question>
    }
    @case (POLLQUESTIONTYPE['1-5_SCALE']) {
      <bdo-agree-question [questionData]="questionData()" (sendAnswer)="sendAnswer.emit($event)"></bdo-agree-question>
    }
    @case (POLLQUESTIONTYPE.FREE_TEXT) {
      <bdo-freetext-question [questionData]="questionData()" (sendAnswer)="sendAnswer.emit($event)"></bdo-freetext-question>
    }
    @case (POLLQUESTIONTYPE.BOOLEAN) {
      <bdo-boolean-question [questionData]="questionData()" (sendAnswer)="sendAnswer.emit($event)"></bdo-boolean-question>
    }
    @default {
      <!-- Unknown -->
    }
  }
</div>
